import { isSimpleCardType } from './isSimpleCardType';
import LegacySidebarComponentWithDataRequest from './LegacySidebarComponentWithDataRequest';
import { ObjectTypeFromIds } from 'customer-data-objects/constants/ObjectTypeIds';
import { LEGACY_SIDEBAR_CARDS_WITH_PERFORMANCE_MARKERS } from './LegacySidebarCardsWithPerformanceMarkers';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function LegacySidebarComponentAdapter(props) {
  const {
    CardComponent,
    objectId,
    objectTypeId,
    cardType,
    cardData,
    extraProps,
    isEditable,
    renderLoadingIndicator,
    renderErrorState,
    SuccessMarker,
    ErrorMarker,
    CardContentLoadingComponent
  } = props;
  const objectTypeName = ObjectTypeFromIds[objectTypeId];

  // A simple card does not require a data request from the adapter.
  // In the CustomerDataSidebar, these cards did not receive their CRM data
  // from the sidebar itself, other than basic card info.
  // So it can just render the card, otherwise we need to render
  // the dataRequest version.
  if (isSimpleCardType(cardType)) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [SuccessMarker && !LEGACY_SIDEBAR_CARDS_WITH_PERFORMANCE_MARKERS.has(cardType) && /*#__PURE__*/_jsx(SuccessMarker, {}), /*#__PURE__*/_jsx(CardComponent, Object.assign({
        subjectId: `${objectId}`,
        objectId: `${objectId}`,
        objectType: objectTypeName || objectTypeId,
        data: cardData,
        isEditable: isEditable,
        ErrorMarker: ErrorMarker,
        SuccessMarker: SuccessMarker,
        CardContentLoadingComponent: CardContentLoadingComponent,
        renderLoadingIndicator: renderLoadingIndicator
      }, extraProps))]
    });
  }
  return /*#__PURE__*/_jsx(LegacySidebarComponentWithDataRequest, {
    objectId: objectId,
    objectTypeId: objectTypeId,
    cardType: cardType,
    cardData: cardData,
    CardComponent: CardComponent,
    extraProps: extraProps,
    isEditable: isEditable,
    renderLoadingIndicator: renderLoadingIndicator,
    renderErrorState: renderErrorState,
    SuccessMarker: SuccessMarker,
    ErrorMarker: ErrorMarker,
    CardContentLoadingComponent: CardContentLoadingComponent
  });
}
export default LegacySidebarComponentAdapter;